<section class="rounded-lg bg-primary-50 p-4">
  <form
    class="flex flex-col gap-2"
    [formGroup]="this.transportFormService.transportForm"
  >
    <h4 class="text-primary-900">
      {{ "prestation.timForm.title" | transloco }}
    </h4>
    <p
      class="rounded-lg border border-error-500 bg-error-50 p-2 text-paragraph-s-reg text-error-500"
    >
      {{ "timWarning.calculator" | transloco }}
    </p>
    <div class="flex flex-1 flex-col gap-2 md:flex-row">
      <app-select-airport
        class="flex flex-1"
        placeholder="from"
        [formGroup]="this.transportFormService.flightStopsControls[0]"
        data-testid="airport-from-input"
      />
      <app-select-airport
        class="flex flex-1"
        placeholder="to"
        [formGroup]="
          this.transportFormService.flightStopsControls[
            this.transportFormService.flightStops.length - 1
          ]
        "
        data-testid="airport-to-input"
      />
    </div>
    <div class="flex flex-col gap-2 md:flex-row">
      <div class="flex flex-1 flex-col">
        <label
          for="carrierCode"
          class="text-left text-paragraph-xs-med text-greyscale-700"
        >
          {{ "calculator.placeholder.carrierCode" | transloco }} *
        </label>
        <input
          type="text"
          placeholder="{{ 'calculator.placeholder.carrierCode' | transloco }}"
          formControlName="carrierCode"
          pInputText
          [fluid]="true"
        />
        <app-error
          [control]="transportFormService.transportForm.get('carrierCode')!"
        />
      </div>
      <div class="flex flex-1 flex-col">
        <label
          for="flightNumber"
          class="text-left text-paragraph-xs-med text-greyscale-700"
        >
          {{ "calculator.placeholder.flightNumber" | transloco }} *
        </label>
        <input
          type="text"
          placeholder="{{ 'calculator.placeholder.flightNumber' | transloco }}"
          formControlName="flightNumber"
          pInputText
          [fluid]="true"
        />
        <app-error
          [control]="transportFormService.transportForm.get('flightNumber')!"
        />
      </div>
      <div class="flex flex-1 flex-col">
        <label
          for="flightDate"
          class="text-left text-paragraph-xs-med text-greyscale-700"
        >
          {{ "calculator.placeholder.flightDate" | transloco }} *
          <app-tooltip-icon
            [message]="'calculator.flightDate.tooltip' | transloco"
          />
        </label>
        <input
          type="date"
          placeholder="{{ 'calculator.placeholder.flightDate' | transloco }}"
          formControlName="flightDate"
          pInputText
          [fluid]="true"
        />
        <app-error
          [control]="transportFormService.transportForm.get('flightDate')!"
        />
      </div>
    </div>
  </form>
</section>
